import { StatusPanel } from '../components/StatusPanel';
import { useKidStatus } from '../hooks/useKidStatus';
import { useNow } from '../hooks/useNow';

/**
 * The public board: three full-bleed panels and nothing else. Stacked on a
 * phone held upright, side by side once there is width to spare.
 *
 * The dynamic viewport unit keeps the bottom panel clear of mobile browser
 * chrome as it expands and collapses on scroll.
 */
export function Board() {
  const { kids, loading, stale } = useKidStatus();
  useNow(); // keeps the "updated x ago" lines current between polls

  return (
    <>
      <h1 className="sr-only">Can the kids play?</h1>

      <main
        aria-busy={loading}
        className="grid h-dvh w-full grid-rows-3 gap-0.5 bg-white/10 sm:landscape:grid-cols-3 sm:landscape:grid-rows-none"
      >
        {loading ? (
          <p className="row-span-full grid place-content-center bg-page text-sm tracking-[0.08em] text-ink-muted uppercase sm:landscape:col-span-full sm:landscape:row-span-1">
            Loading…
          </p>
        ) : kids && kids.length > 0 ? (
          kids.map((kid) => <StatusPanel key={kid.slug} kid={kid} />)
        ) : (
          <p className="row-span-full grid place-content-center bg-page px-6 text-center text-sm text-ink-muted sm:landscape:col-span-full sm:landscape:row-span-1">
            Cannot reach the status board. Retrying…
          </p>
        )}
      </main>

      {stale && kids && kids.length > 0 && (
        <div
          role="status"
          className="fixed bottom-[max(0.9rem,env(safe-area-inset-bottom))] left-1/2 max-w-[min(92vw,30rem)] -translate-x-1/2 rounded-full bg-black/85 px-4 py-2 text-center text-xs text-white shadow-lg backdrop-blur-sm"
        >
          Showing the last known status — reconnecting…
        </div>
      )}
    </>
  );
}
